import { render, staticRenderFns } from "./Titular.vue?vue&type=template&id=097b2c60&"
import script from "./Titular.vue?vue&type=script&lang=js&"
export * from "./Titular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports